import { render, staticRenderFns } from "./listModalComponent.vue?vue&type=template&id=028ac435&scoped=true&"
import script from "./listModalComponent.vue?vue&type=script&lang=js&"
export * from "./listModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./listModalComponent.vue?vue&type=style&index=0&id=028ac435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ac435",
  null
  
)

export default component.exports